import { Pipe, PipeTransform } from '@angular/core';
import { deltaToHtml } from './rich-text';

/*
 * Renders a stored message Delta (`textDelta`) as HTML, '' when there is nothing to render.
 * Bind the result to [innerHtml] without bypassing Angular's sanitizer.
 */
@Pipe({ name: 'richText' })
export class RichTextPipe implements PipeTransform {
    transform(value: string): string {
        return deltaToHtml(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/rich-text.pipe.ts